<template>
  <main class="main page-inside">
    <div class="main-wrapper">
      <div class="section hero-section">
        <div class="wrapper">
          <div class="content">
            <div class="card-list">
              <template v-if="!$parent.checkoutSuccess">
                <div class="card-list__item order-details">
                  <div class="title small">{{ $t(`Order details`) }}</div>
                  <div class="desc">{{ $t(`Choose payment method:`) }}</div>
                  <div class="radio-list">
                    <div class="list">
                      <div class="item" v-if="!$parent.fiatToCrypto">
                        <label>
                          <input
                            type="radio"
                            v-model="paymentMethod"
                            name="paymentMethod"
                            value="crypto"
                          />
                          <div class="text">
                            <div class="desc">{{ $t("Crypto") }}</div>
                          </div>
                        </label>
                      </div>

                      <template v-else>
                        <div
                          class="item"
                          v-for="(method, index) in availablePaymentMethods"
                          :key="index"
                        >
                          <label>
                            <input
                              type="radio"
                              v-model="paymentMethod"
                              name="paymentMethod"
                              :value="method.code"
                            />
                            <div class="text">
                              <img
                                v-if="method.image_full"
                                :src="method.image_full"
                                class="img"
                              />
                              <div class="desc">{{ $t(method.title) }}</div>
                            </div>
                          </label>
                        </div>
                      </template>
                    </div>
                  </div>
                  <div class="input-container">
                    <div class="desc">{{ $t(`Wallet:`) }}</div>
                    <input type="text" v-model="wallet" />
                    <div class="clue">
                      {{ $t(`Please provide your wallet`) }}
                    </div>
                  </div>
                  <div class="total">
                    <div class="desc">{{ $t(`Total amount to pay:`) }}</div>
                    <div class="total-wrapper">
                      <div class="item">
                        <div class="text">
                          <div class="desc">{{ $t(`Date of order`) }}</div>
                          <div class="desc">{{ currentDate }}</div>
                        </div>
                        <div
                          class="title"
                          :class="{ crypto: !$parent.fiatToCrypto }"
                        >
                          {{ leftAmount }}
                        </div>
                      </div>
                      <div class="item">
                        <div class="text">
                          <div class="desc">{{ $t(`Exchange rate`) }}</div>
                          <div class="desc">
                            1 {{ $parent.takeCurrency.crypto_currency }} =
                            {{ $parent.takeCurrency.price }}
                            {{ $parent.giveCurrency.symbol }}
                          </div>
                        </div>
                        <div
                          class="title"
                          :class="{ crypto: $parent.fiatToCrypto }"
                        >
                          {{ rightAmount }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="total-bottom">
                    <router-link to="buy-crypto" class="button gray">{{
                      $t(`Cancel order`)
                    }}</router-link>
                    <button class="button" @click="submit">
                      {{ $t(`Continue`) }}
                    </button>
                  </div>
                </div>
                <div class="card-list__item-container">
                  <div class="card-list__item your-card">
                    <div class="title small">{{ $t(`Your Card`) }}</div>
                    <div class="row">
                      <div class="title">{{ leftAmount }}</div>
                      <router-link to="buy-crypto" class="button gray">{{
                        $t(`Change amount`)
                      }}</router-link>
                    </div>
                    <div class="desc">{{ rightAmount }}</div>
                    <div class="table">
                      <div class="row">
                        <div class="desc">{{ $t(`Exchange rate`) }}</div>
                        <div class="desc">
                          1 {{ $parent.takeCurrency.crypto_currency }} =
                          {{ $parent.takeCurrency.price }}
                          {{ $parent.giveCurrency.symbol }}
                        </div>
                      </div>
                      <div class="row">
                        <div class="desc">
                          {{
                            $t(
                              $parent.fiatToCrypto
                                ? "Coins to receive"
                                : "Money to receive"
                            )
                          }}
                        </div>
                        <div class="desc">{{ rightAmount }}</div>
                      </div>
                    </div>
                  </div>
                  <div class="timer">
                    <div class="title white">
                      {{ hours }}:{{ minutes }}:{{ seconds }}
                    </div>
                    <div class="desc">
                      {{ $t(`The price is fixes for 1 hour`) }}
                    </div>
                  </div>
                </div>
              </template>
              <template v-else>
                <div class="card-list__item order-success">
                  <div class="order-submit-success">
                    <div class="order-submit-success__title">
                      {{ $t(`Order successfully submitted`) }}
                    </div>
                    <div class="order-submit-success__message"></div>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
import fiatSection from "@/components/FiatSection.vue";

export default {
  name: "OrderDetails",
  props: {
    feePercentage: Number,
  },
  components: {},
  data: function () {
    return {
      paymentMethod: null,
      availablePaymentMethods: [],
      wallet: "",
      hours: 1,
      minutes: 0,
      seconds: 0,
      timer: null,
      currentDate: "",
      submitSuccess: false,
    };
  },
  watch: {},
  mounted: function () {
    if (this.$parent.fiatToCrypto) {
      this.fetchAvailablePaymentMethods();
    }
    if (this.$parent.paymentMethod) {
      this.paymentMethod = this.$parent.paymentMethod;
    }

    this.$parent.changeCheckoutSuccess(false);
    this.startTimer();
    this.getCurrentDate();
  },
  methods: {
    fetchAvailablePaymentMethods() {
      this.$http
        .post(`available-methods`, {
          currency: this.$parent.giveCurrency.code,
        })
        .then((response) => {
          if (response.data.status === "OK") {
            this.availablePaymentMethods = response.data.payload;

            if (!this.paymentMethod) {
              this.paymentMethod =
                this.availablePaymentMethods[0]?.code || null;
            }
          } else {
            this.availablePaymentMethods = [];
          }
        })
        .catch((error) => {
          this.availablePaymentMethods = [];
          console.error("Error fetching payment methods:", error);
        });
    },
    getCurrentDate() {
      const today = new Date();
      const formattedDate = today.toISOString().split("T")[0];

      this.currentDate = formattedDate;
    },
    startTimer() {
      this.timer = setInterval(() => {
        if (this.hours === 0 && this.minutes === 0 && this.seconds === 0) {
          clearInterval(this.timer);
        } else {
          if (this.seconds > 0) {
            this.seconds--;
          } else {
            if (this.minutes > 0) {
              this.minutes--;
              this.seconds = 59;
            } else {
              this.hours--;
              this.minutes = 59;
              this.seconds = 59;
            }
          }
        }
      }, 1000);
    },
    submit() {
      if (!this.paymentMethod) {
        this.$toast("Please select a payment method", { type: "error" });
        return;
      }
      this.$parent.openPersonalInfoModal();
      this.$emit("setWallet", this.wallet);
      this.$emit("setPaymentMethod", this.paymentMethod);
    },
  },
  computed: {
    fiatSection() {
      return fiatSection;
    },
    leftAmount() {
      const parent = this.$parent;
      return parent.fiatToCrypto
        ? `${parent.giveCurrency.symbol} ${parseFloat(
            parent.giveAmount
          ).toFixed(2)}`
        : `${parent.takeAmount.toFixed(8)} ${
            parent.takeCurrency.crypto_currency
          }`;
    },
    rightAmount() {
      const parent = this.$parent;
      const takeAmount = parent.takeAmount || 0;
      const giveAmount = parent.giveAmount || 0;
      return parent.fiatToCrypto
        ? `${takeAmount.toFixed(8)} ${parent.takeCurrency.crypto_currency}`
        : `${parent.giveCurrency.symbol} ${parseFloat(giveAmount).toFixed(2)}`;
    },
  },
};
</script>
